import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CreditPayload, UserService } from 'src/app/core/services/user-service.service';
import { SnackbarService } from 'src/app/core/services/snackbar.service';

export interface UpdateCreditsModalData {
  userId: string;
  credits: number;
}

interface TransactionOption {
  value: CreditPayload['transactionType'];
  label: string;
}

@Component({
  selector: 'app-update-credits-modal',
  templateUrl: './update-credits-modal.component.html',
  styleUrls: ['./update-credits-modal.component.scss']
})
export class UpdateCreditsModalComponent {
  creditsForm: FormGroup;
  isLoading: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<UpdateCreditsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: UpdateCreditsModalData,
    private fb: FormBuilder,
    private userService: UserService,
    private snackbarService: SnackbarService
  ) {
    this.creditsForm = this.fb.group({
      credits: [0, [Validators.required, Validators.min(1), Validators.max(1000000)]],
      transactionType: ['credit', [Validators.required, Validators.pattern(/^(credit|debit)$/)]]
    });
  }
  transactionOptions: TransactionOption[] = [
    { value: 'credit', label: 'Credit' },
    { value: 'debit', label: 'Debit' }
  ]

  onSubmit(): void {
    if (this.creditsForm.invalid) {
      this.creditsForm.markAllAsTouched();
      return;
    }

    this.isLoading = true;
    const creditPayload = {
      amount: this.creditsForm.value.credits,
      transactionType: this.creditsForm.value.transactionType
    };

    this.userService.updateCredits(this.data.userId, creditPayload).subscribe({
      next: (res: any) => {
        this.snackbarService.showSuccess('Credits updated successfully!');
        this.dialogRef.close(true);
      },
      error: (error: any) => {
        this.snackbarService.showError(error.error?.message || 'Failed to update credits!');
        this.isLoading = false;
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
